import { render } from "./ListTableEducation.vue?vue&type=template&id=68a64122&scoped=true"
import script from "./ListTableEducation.vue?vue&type=script&lang=js"
export * from "./ListTableEducation.vue?vue&type=script&lang=js"

import "./ListTableEducation.vue?vue&type=style&index=0&id=68a64122&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a64122"]])

export default __exports__